import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';

const status = createReducer(ActionTypes.USER_LOGIN_CHECK_UNKNOWN, {
  [ActionTypes.USER_LOGIN_CHECK_SUCCESS]: (state, { type }) => type
});

const passwordStatus = createReducer(null, {
  [ActionTypes.SET_PASSWORD_SUCCESS]: (state, { type }) => type,
  [ActionTypes.SET_PASSWORD_ERROR]: (state, { type }) => type
});

const connectFacebookStatus = createReducer(null, {
  [ActionTypes.FACEBOOK_CONNECT_SUCCESS]: (state, { type }) => type
});

const data = createReducer(null, {
  [ActionTypes.USER_LOGIN_CHECK_SUCCESS]: (state, { payload }) => payload,
  [ActionTypes.USER_LOGIN_ERROR]: (state, { payload }) => ({ ...state, login_error: payload })
});

const token = createReducer(
  { value: null },
  {
    [ActionTypes.USER_LOGIN_CHECK_SUCCESS]: (state, { payload }) => ({
      value: payload.jwt || state.value
    }),
    [ActionTypes.USER_SET_JWT]: (state, { payload }) => ({
      value: payload
    })
  }
);

export default combineReducers({
  status,
  passwordStatus,
  connectFacebookStatus,
  data,
  token
});
